export default __webpack_public_path__ + "static/media/Castle_Guardians_3D_Master.5900db8b.png";